import { HostListener, Directive } from '@angular/core';
import { HomepageNavigatorService } from '~shared/modules/homepage-navigator/homepage-navigator.service';

@Directive({
  selector: '[homepageLink]',
})
export class HomepageLinkDirective {
  constructor
  (
    private readonly homepageNavigator: HomepageNavigatorService,
  ) {
  }

  @HostListener('click', ['$event'])
  public onClick(e): boolean {
    e.stopPropagation();
    e.preventDefault();

    this.homepageNavigator.navigateToHomepage().subscribe();

    return false;
  }
}
